import { catchError } from 'rxjs/operators';
import {
  HttpErrorResponse,
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest
} from '@angular/common/http';
import { NotificationService } from '../../notification';
import { Observable, throwError } from 'rxjs';
import { ApiErrorStatus } from '../enums';

export class ForbiddenErrorInterceptor implements HttpInterceptor {
  constructor(
    private notificationService: NotificationService
  ) { }

  public intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next
      .handle(request)
      .pipe(
        catchError((response: HttpErrorResponse) => {
          if (response.status === ApiErrorStatus.FORBIDDEN) {
            this.notificationService.error('Failed to perform action: This action is unauthorized.');
          }

          return throwError(response);
        }),
      );
  }
}
